import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BreadcrumbService } from '@services/breadcrumb.service';
import { BaseModal } from '../base-modal';

@Component({
    selector: 'legal-modal',
    styleUrls: ['./legal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        <div class="modal-body">
        <button class="close" (click)="closeAndDestroy()">
            <i class="fa-light fa-xmark"></i>
        </button>
        <div class="legal-item">
            <div>
                <h3>{{content?.name}}</h3>
                <div [innerHTML]="$safeNavigationMigration(content?.header)"></div>
                <div [innerHTML]="$safeNavigationMigration(content?.content)"></div>
                <br>
            </div>
        </div>
        </div>
    `,
})
export class LegalComponent extends BaseModal {

	content: { name: string, header: string, content: string } | null = null;

	constructor(
		breadcrumbService: BreadcrumbService
	) {
		super(breadcrumbService);
	}

}
